import { render, staticRenderFns } from "./UsersManagement.vue?vue&type=template&id=23570a90"
import script from "./UsersManagement.vue?vue&type=script&lang=js"
export * from "./UsersManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports